import PhotoSwipeLightbox from 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe-lightbox.esm.min.js';

const SECTION_SELECTOR = '.main-product[data-image-zoom-mode="photoswipe"]';

function initPhotoSwipe(section) {
  if (!section || section.dataset.photoswipeBound === 'true') return;

  const galleryItems = section.querySelectorAll('.js-product-photoswipe-item');
  if (!galleryItems.length) return;

  const lightbox = new PhotoSwipeLightbox({
    gallery: `#${section.id}`,
    children: '.js-product-photoswipe-item',
    pswpModule: () => import('https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.esm.min.js'),
    showHideAnimationType: 'zoom',
    bgOpacity: 0.92,
    wheelToZoom: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,
  });

  lightbox.init();
  section.dataset.photoswipeBound = 'true';
}

function initAll(root = document) {
  root.querySelectorAll(SECTION_SELECTOR).forEach(initPhotoSwipe);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll(document));
} else {
  initAll(document);
}

document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target);
});
